export const RETRY_FETCH = 'mallStats/RETRY_FETCH';
